<template>
  <Layout>
    <div class="banner-page">
      <img src="/img/banner/produk-banner.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>Produk Kami</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section produk-section">
      <div class="container">
        <div class="section-title text-center">Produk Kami</div>
        <div class="row">
          <div class="col-md-5 col-xl-4 d-block d-md-none">
            <div class="full-height valign-wrapper">
              <div class="valign-box">
                <img
                  src="/img/img-produk-1.png"
                  class="img-produk"
                  alt="Image"
                />
              </div>
            </div>
          </div>
          <div class="col-md-7 col-xl-8 valign-wrapper">
            <div class="valign-box">
              <div class="section-subtitle color-main">
                Masjed.id Apps
              </div>
              <p>
                Masjed adalah aplikasi ekosistem masjed 'Single Device
                Multi Platform and Multi User' yang dilengkap dengan
                feature-feature yang bermanfaat berbasis Masjed
                sebagai pusat perkembangan peradaban untuk
                kemaslahatan dan keberkahan menuju kemakmuran dunia
                dan akhirat yang berkeadilan sosial meraih
                Rahmatan-lil-alamin. Aplikasi masjed hadir untuk
                memudahkan dalam pengelolaan manajemen masjed dan
                manajemen Ziswaf dan Donasi. Aplikasi masjed.id
                menghadirkan banyak fitur bermanfaat, guna memudahkan
                dalam pembuatan laporan pertanggungjawaban keuangan
                masjed, memperluas jaringan donasi dan kampanye
                pendanaan melalui fitur Pembayaran secara online,
                sehingga masjed mendapatkan santunan penyaluran Ziswaf
                dan Donasi yang dapat dirasakan langsung oleh masjed,
                DKM masjed, ustadz, relawan, jamaah, dan dhuafa
                masjed. masjed.id mendorong kegiatan pemberdayaan
                ekonomi melalui kegiatan usaha serambi masjed, yang
                dapat membantu meningkatkan kesejahteraan pengurus
                masjed dan lingkungannya.
              </p>
              <a
                href="https://masjed.id/app/site/register"
                class="btn btn-main d-block d-md-inline-block btn-wide mt-16"
                >Daftar Sekarang</a
              >
            </div>
          </div>
          <div class="col-md-5 col-xl-4 d-none d-md-block">
            <div class="full-height valign-wrapper">
              <div class="valign-box text-right">
                <img src="/img/img-produk-1.png" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section produk-section bg-grey">
      <div class="container">
        <div class="row">
          <div class="col-md-4 valign-wrapper">
            <div class="valign-box">
              <img
                src="/img/img-produk-2.png"
                class="img-produk"
                alt="Image"
              />
            </div>
          </div>
          <div class="col-md-8 valign-wrapper">
            <div class="valign-box">
              <div class="section-subtitle color-main">
                Usaha Serambi
              </div>
              <p>
                Usaha Serambi adalah salah satu program yang dimiliki
                oleh aplikasi masjed.id. Program ini memberikan
                kesempatan kepada jama’ah, relawan, asatidz, dhuafa
                dan yatim untuk mendukung pemberdayaan ekonomi
                keumatan/kerakyatan di lingkungan masjed yang di
                fasilitasi dan di dukung oleh DKM masjed.
              </p>
              <p>
                Dengan kegiatan usaha serambi, jama’ah, relawan,
                asatidz, dhuafa dan yatim bisa berjualan berbagai
                produk yang tersedia di aplikasi masjed.id dan tanpa
                perlu bingung memikirkan modal usaha yang dibutuhkan,
                karena tidak mengeluarkan modal untuk menjalankan
                usaha serambi. Tujuan dari program Usaha Serambi
                adalah memakmurkan masjed dengan mengembalikan fungsi
                masjed sebagai pusat peradaban manusia dimana berbagai
                kegiatan umat dilaksanakan di sana baik kegiatan
                ibadah maupun kegiatan muamalah.
              </p>
              <a
                href="#"
                class="btn btn-main d-block d-md-inline-block btn-wide mt-16"
                >Daftar Sekarang</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section produk-section">
      <div class="container">
        <div class="row">
          <div class="col-md-4 d-block d-md-none">
            <div class="full-height valign-wrapper">
              <div class="valign-box">
                <img
                  src="/img/img-produk-3.png"
                  class="img-produk"
                  alt="Image"
                />
              </div>
            </div>
          </div>
          <div class="col-md-8 valign-wrapper">
            <div class="valign-box">
              <div class="section-subtitle color-main">UstadMu</div>
              <p>
                PT MASJED INDONESIA DIGITAL terus berkomitmen untuk
                menyebarkan kebaikan, insya Allah PT MASJED INDONESIA
                DIGITAL juga meluncurkan aplikasi digital lainnya yang
                bernama UstadMU. Aplikasi UstadMU ini dikembangkan
                untuk memudahkan asatidz untuk menyebarluaskan dakwah,
                tablig, dan khutbah ataupun kajian kepada jama’ah
                dimanapun berada.
              </p>
              <p>
                Aplikasi UstadMU ini hadir untuk membantu memudahkan
                hubungan jama’ah dengan ustad. Semoga Allah memudahkan
                aplikasi ini berjalan dengan baik dan lancar dan bisa
                membantu ustad maupun jama’ah.
              </p>
              <a
                href="#"
                class="btn btn-main d-block d-md-inline-block btn-wide mt-16"
                >Daftar Sekarang</a
              >
            </div>
          </div>
          <div class="col-md-4 d-none d-md-block">
            <div class="full-height valign-wrapper">
              <div class="valign-box text-right">
                <img src="/img/img-produk-3.png" alt="Image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="page-section produk-section bg-grey">
      <div class="container">
        <div class="row">
          <div class="col-md-4 valign-wrapper">
            <div class="valign-box">
              <img src="/img/img-produk-4.png" class="img-produk" alt="Image" />
            </div>
          </div>
          <div class="col-md-8 valign-wrapper">
            <div class="valign-box">
              <div class="section-subtitle color-main">MuMu Apps</div>
              <p>
                Selain mengembangkan aplikasi masjed.id, PT MASJED INDONESIA 
                DIGITAL juga sudah meluncurkan aplikasi digital lainnya yang
                bernama Membangun Umat Menguatkan Ukhuwah (MUMU) di bulan
                November 2019. Aplikasi MUMU ini adalah platform E-Business yang
                memudahkan Wakif, Muzzaki, Mustahik, maupun Munfik bertemu dalam
                suatu ekosistem digital. Aplikasi MUMU bertujuan untuk
                memudahkan masyarakat berdonasi, bertransaksi, dan mengakses
                keuangan inklusif.
              </p>
              <p>
                Tidak hanya melayani kebutuhan masyarakat dalam kemudahan
                berdonasi, aplikasi MUMU juga memudahkan kebutuhan harian
                masyarakat, seperti melakukan pembayaran listrik, PDAM, atau
                membeli pulsa. Aplikasi MUMU juga dilengkapi E-Commerce produk
                UMKM lokal Indonesia untuk membantu meningkatkan kesejahteraan
                petani dan pengusaha kecil. Insya Allah dengan aplikasi MUMU
                menjadi lebih Amanah, mudah, dan berkah.
              </p>
              <a
                href="#"
                class="btn btn-main d-block d-md-inline-block btn-wide mt-16"
                >Daftar Sekarang</a
              >
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="page-section produk-list-wrapper">
      <div class="container">
        <div class="section-subtitle color-main text-center mb-24">
          Produk Islami
        </div>
        <div class="produk-multibiller-container">
          <div>
            <a href="#modal-produk-1" data-bs-toggle="modal">
              <img src="/img/zakat.svg" alt="Image" />
              <p>Zakat</p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-2" data-bs-toggle="modal">
              <img src="/img/infaq-sedekah.svg" alt="Image" />
              <p>
                Infaq & <br />
                Sedekah
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-3" data-bs-toggle="modal">
              <img src="/img/asuransi-syariah.svg" alt="Image" />
              <p>
                Asuransi <br />
                Syariah
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-4" data-bs-toggle="modal">
              <img src="/img/akikah.svg" alt="Image" />
              <p>Akikah</p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-5" data-bs-toggle="modal">
              <img src="/img/kurban.svg" alt="Image" />
              <p>Kurban</p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-6" data-bs-toggle="modal">
              <img src="/img/umrah-haji.svg" alt="Image" />
              <p>
                Umrah & <br />
                Haji
              </p>
            </a>
          </div>
        </div>
        <div
          class="section-subtitle color-main text-center mt-40 mb-24"
        >
          Top Up & Isi Pulsa
        </div>
        <div class="produk-multibiller-container">
          <div>
            <a href="#modal-produk-7" data-bs-toggle="modal">
              <img src="/img/pulsa-data.svg" alt="Image" />
              <p>
                Pulsa & <br />
                Data
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-8" data-bs-toggle="modal">
              <img src="/img/tagihan-telepon.svg" alt="Image" />
              <p>
                Tagihan <br />
                Telepon
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-9" data-bs-toggle="modal">
              <img src="/img/tagihan-listrik.svg" alt="Image" />
              <p>
                Tagihan <br />
                Listrik
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-10" data-bs-toggle="modal">
              <img src="/img/emoney.svg" alt="Image" />
              <p>
                Top-Up <br />
                Uang Elektronik
              </p>
            </a>
          </div>
        </div>
        <div
          class="section-subtitle color-main text-center mt-40 mb-24"
        >
          Produk Keuangan dan Perbankan
        </div>
        <div class="produk-multibiller-container">
          <!-- <div>
            <a href="#modal-produk-11" data-bs-toggle="modal">
              <img src="/img/bsi-multibiller.svg" alt="Image" />
              <p>
                Buka <br />
                Rekening
              </p>
            </a>
          </div> -->
          <div>
            <a href="#modal-produk-bni" data-bs-toggle="modal">
              <img src="/bni.png" alt="Image" style="width: 100px" />
              <p>
                BNI Pandai
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-12" data-bs-toggle="modal">
              <img src="/img/agen-linkaja.svg" alt="Image" />
              <p>
                Agen <br />
                LinkAja
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-13" data-bs-toggle="modal">
              <img src="/img/cetak-qris.svg" alt="Image" />
              <p>
                Cetak <br />
                QRIS
              </p>
            </a>
          </div>
          <div>
            <a href="#modal-produk-14" data-bs-toggle="modal">
              <img src="/img/BSI.png" alt="Image" />
              <p>
                BSI BUREKOL
              </p>
            </a>
          </div>
          <!-- <div>
                        <a href="#">
                            <img src="/img/tabungan-now.svg" alt="Image" />
                            <p>
                                Tabungan <br />
                                Now
                            </p>
                        </a>
                    </div> -->
        </div>
      </div>
    </section>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/zakat.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">Zakat</div>
                  <p class="no-margin">
                    Fitur ini membantu untuk memudahkan pengguna
                    aplikasi masjed.id untuk berzakat dan bisa memilih
                    lembaga amil zakat. Dan tersedia pula fitur
                    Kalkulator Zakat yang memudahkan perhitungan zakat
                    yang harus ditunaikan sesuai ketentuan Syariah.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-2"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/infaq-sedekah.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">
                    Infaq & Sedekah
                  </div>
                  <p class="no-margin">
                    Fitur ini membantu untuk memudahkan proses infaq
                    dan sedekah yang ingin dilakukan dan pengguna
                    aplikasi bisa memilih sendiri Lembaga amil yang
                    tersedia.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-3"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/asuransi-syariah.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">
                    Asuransi Syariah
                  </div>
                  <p class="no-margin">
                    Menurut Fatwa Dewan Syariah Nasional (DSN),
                    Asuransi Syariah diartikan sebagai usaha saling
                    melindungi dan tolong-menolong di antara sejumlah
                    orang atau pihak melalui investasi dalam bentuk
                    aset atau tabarru’ uang memberikan pola
                    pengembalian untuk menghadapi risiko tertentu
                    melalui akad (perikatan) yang sesuai dengan
                    Syariah.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-4"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/akikah.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">Akikah</div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna aplikasi masjed.id
                    untuk membeli dan mendistribusikan akikah kepada
                    penerima yang lebih luas dan bermanfaat. Pengguna
                    aplikasi masjed.id juga bisa memilih sendiri
                    partner akikah yang sudah disediakan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-5"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/kurban.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">Kurban</div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna aplikasi masjed.id
                    untuk membeli dan mendistribusikan kurban kepada
                    penerima yang lebih luas dan bermanfaat. Pengguna
                    aplikasi masjed.id juga bisa memilih sendiri
                    partner kurban yang sudah disediakan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-6"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/umrah-haji.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Islami
                  </div>
                  <div class="program-title-modal">Haji & Umrah</div>
                  <p class="no-margin">
                    Fitur ini memberikan informasi Umrah dan Haji
                    (kumpulan do’a) dan juga tersedia berbagai pilihan
                    travel tour umrah dan haji yang bisa pengguna
                    aplikasi masjed.id pilih.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-7"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/pulsa-data.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Top-Up & Pulsa
                  </div>
                  <div class="program-title-modal">Pulsa & Data</div>
                  <p class="no-margin">
                    Fitur ini memberikan kemudahan pengguna aplikasi
                    masjed.id untuk membeli pulsa atau membayar
                    tagihan data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-8"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/tagihan-telepon.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Top-Up & Pulsa
                  </div>
                  <div class="program-title-modal">
                    Tagihan Telepon
                  </div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna aplikasi masjed.id
                    untuk membayar tagihan telepon.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-9"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/tagihan-listrik.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Top-Up & Pulsa
                  </div>
                  <div class="program-title-modal">
                    Tagihan Listrik
                  </div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna aplikasi masjed.id
                    untuk membayar tagihan listrik.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-10"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/emoney.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Top-Up & Pulsa
                  </div>
                  <div class="program-title-modal">
                    Top-Up Uang Elektronik
                  </div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna aplikasi masjed.id
                    untuk menambahkan saldo Uang Elektronik.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-11"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/bsi-multibiller.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Keuangan dan Perbankan
                  </div>
                  <div class="program-title-modal">Buka Rekening</div>
                  <p class="no-margin">
                    Memudahkan pengguna aplikasi masjed.id untuk membuka
                    rekening bank BSI secara online. Tujuan membuka rekening
                    bank BSI melalui aplikasi masjed.id adalah untuk memudahkan
                    bertansaksi dalam satu genggaman tangan, pengguna aplikasi
                    bisa melakukan transfer uang dan menerima uang dari orang
                    lain, dan atau melakukan transaksi usaha serambi masjid yang
                    dilakukan di masjed.id
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-12"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/agen-linkaja.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Keuangan dan Perbankan
                  </div>
                  <div class="program-title-modal">Agen LinkAja</div>
                  <p class="no-margin">
                    LinkAja adalah sebuah layanan uang elektronik yang
                    berbasis aplikasi untuk melakukan berbagai
                    transaksi nontunai dengan mudah dan praktis.
                    Layanan yang satu ini dapat anda gunakan
                    sebagaimana layaknya layanan Keuangan berbasis
                    digital lainnya, yang membuat berbagai transaksi
                    keuangan bisa dilakukan dengan mudah dan cepat.
                    <br />
                    LinkAja menjadi salah satu pilihan pembayaran yang
                    bisa digunakan saat bertransaksi di aplikasi
                    masjed.id.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-13"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/cetak-qris.svg" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Keuangan dan Perbankan
                  </div>
                  <div class="program-title-modal">Cetak QRIS</div>
                  <p class="no-margin">
                    Fitur ini memudahkan pengguna untuk melakukan
                    penambahan saldo DompetMU maupun melakukan
                    pembayaran hanya dengan mencetak QRIS.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-14"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/img/BSI.png" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Keuangan dan Perbankan
                  </div>
                  <div class="program-title-modal">BSI BUREKOL</div>
                  <p class="no-margin">
                    Buka rekening sekarang bisa kapan saja dan dimana
                    saja, tanpa perlu khawatir kehilangan momen
                    penting bersama keluarga dan tidak repot karena
                    harus antri di Bank. BSI Burekol lebih mudah,
                    simpel dan lebih cepat.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BNI -->
    <div
      class="modal fade program-modal produk-modal"
      id="modal-produk-bni"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-x-lg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                />
              </svg>
            </button>
            <div class="row">
              <div class="col-lg-4 valign-wrapper">
                <div class="valign-box text-center">
                  <img src="/bni.png" />
                </div>
              </div>
              <div class="col-lg-8 valign-wrapper">
                <div class="valign-box">
                  <div class="program-subtitle-modal">
                    Produk Keuangan dan Perbankan
                  </div>
                  <div class="program-title-modal">BNI Pandai</div>
                  <p class="no-margin">
                    Agen 46 BNI - Adalah mitra BNI baik perorangan
                    atau badan hukum yang telah bekerja sama dengan
                    BNI yang bertujuan menyediakan dan memudahkan
                    Layanan Perbankan untuk membuka rekening, setoran
                    tunai, tarik tunai, dan layanan multibiller kepada
                    masyarakat.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../views/layouts/Index.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style></style>
